import { useMemo } from 'react';
import { Document } from '@mercator-gcp/types/elastic_search_service/documents/DocumentDetailFilterResponse';
import { EmptyField } from 'components/elements//EmptyField';
import CompanyList from 'components/elements/CompanyList';
import { CompanyItem } from 'types';

type ViewProjectProps = {
  companies?: Document['companies'] | null;
};

const CompaniesCell = ({ companies }: ViewProjectProps) => {
  const compliantCompanies = useMemo(() => {
    return (
      companies
        ?.filter(({ name }) => name)
        .map(({ uuid, aliases, name }) => {
          return {
            uuid: uuid || null,
            aliases: aliases || null,
            name: name || null,
          } as CompanyItem;
        }) || []
    );
  }, [companies]);

  if (!compliantCompanies?.length) {
    return <EmptyField />;
  }

  return (
    <CompanyList
      companyList={compliantCompanies}
      showLink={false}
      showEmptyState={false}
      maxCompaniesToShow={2}
    />
  );
};

export default CompaniesCell;
